const { addActions } = require('js-data-http')

let mapper_options = {
  endpoint: 'invitations',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      }
    },
    hasOne: {
      local_ad_balance: {
        foreignKey: 'invitation_id',
        localField: 'local_ad_balance'
      }
    }
  }
}

module.exports = (store) => {
  let mapper = store.defineMapper('invitation', mapper_options)
  addActions({
    opt_out: {
      pathname: 'opt_out',
      method: 'PUT'
    },
    opt_in: {
      pathname: 'opt_in',
      method: 'PUT'
    }
  })(mapper)
}
